/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitemwebsite3Inputs */

const en_searchreadyitemwebsite3 = /** @type {(inputs: Searchreadyitemwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_searchreadyitemwebsite3 = /** @type {(inputs: Searchreadyitemwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Searchreadyitemwebsite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitemwebsite3 = /** @type {((inputs?: Searchreadyitemwebsite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitemwebsite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitemwebsite3(inputs)
	return de_searchreadyitemwebsite3(inputs)
});
export { searchreadyitemwebsite3 as "searchReadyItemWebsite" }